import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/_services';

@Component({
  selector: 'app-new-homepage-footer',
  templateUrl: './new-homepage-footer.component.html',
  styleUrls: ['./new-homepage-footer.component.less']
})
export class NewHomepageFooterComponent implements OnInit{
  year: number;
  authSubject: any;
  userData: any;

  constructor(private auth: AuthenticationService, private router: Router) { }

  ngOnInit() {
    this.year = new Date().getFullYear();
    this.authSubject = this.auth.isAuthSubject;
    this.userData = this.auth.currentUserValue;
  }

  isRouteActive(pathArray: any[]): boolean {
    let highlight: boolean = false;
    if (pathArray && pathArray.length != 0) {
      pathArray.forEach((path) => {
        if (this.router.isActive(path, false) == true) {
          highlight = true;
          return true;
        }
      });
    }
    return highlight;
  }
}
